export const serviceMotionList = {
    titleMotion: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        transition: { ease: 'linear', duration: 0.5 }
    },
    cardMotion: {
        initial: { opacity: 0, y: 100 },
        animate: { opacity: 1, y: 0 },
        transition: { type: 'spring', stiffness: 300, damping: 20, duration: 0.3 }
    },
    chat02: {
        viewAmount: 0.2
    },
    chat03: {
        secondImgMotion: { // 출처 팝업(souce-pop) 이미지
            initial: { opacity: 0 },
            animate: { opacity: 1 },
            transition: { 
                ease: 'easeOut', 
                duration: 0.4, 
                delay: 1.7
            }
        },
        thirdImgMotion: { // 커서 이미지
            initial: { opacity: 1, x: 0, y: 0 },
            animate: { opacity: 1, x: -120, y: -30 },
            transition: { 
                ease: 'easeIn',
                duration: 0.1,
                delay: 0.9 // 제목 0.5초 + 카드 0.3초 + 0.1초
            }
        },
        fourImgMotion: { // 출처(source) 이미지
            initial: { opacity: 1, scale: 1 },
            animate: { x: 0, y: 0, scale: [1, 1.2, 1] },
            transition: { 
                duration: 0.5,
                delay: 1.1,
                times: [0, 0.6, 1]
            }
        }
    },
    admin02: {
        viewAmount: 0.2,
        contentMotion: {
            initial: { opacity: 0, y: 50 },
            animate: { opacity: 1, y: 0 },
            transition: { 
                type: 'spring', 
                stiffness: 100, 
                damping: 15, 
                duration: 0.2,
                delay: 0.4          
            }
        }
    },
    admin04: {
        contentMotion: {
            initial: { opacity: 0, y: 50 },
            animate: { opacity: 1, y: 0 },
            transition: { 
                type: 'spring', 
                stiffness: 100, 
                damping: 15, 
                duration: 0.2,
                delay: 0.4          
            }
        }
    }
};
